{
  "name": "cropmap",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4220",
    "start:dev": "ng serve --port 4220 --configuration development",
    "start:test": "ng serve --port 4220 --configuration test",
    "shake-proxies": "node scripts/shake-proxies.mjs",
    "shake-proxies:dry": "node scripts/shake-proxies.mjs --dry-run",
    "build": "node scripts/shake-proxies.mjs && ng build",
    "build:dev": "ng build --configuration development",
    "build:test": "node scripts/shake-proxies.mjs && ng build --configuration=test",
    "build:prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --configuration=ci",
    "test:watch": "ng test --configuration=watch",
    "test:ui": "ng test --ui --watch",
    "test:headless": "ng test --configuration=ci",
    "test:ci": "node --max-old-space-size=8192 ./node_modules/@angular/cli/bin/ng test --configuration=ci",
    "test:coverage": "ng test --configuration=ci --coverage",
    "coverage-win:open": "node scripts/open-coverage.mjs",
    "test:debug": "ng test --debug --configuration=watch",
    "test:single": "ng test --watch=false --include",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:install": "playwright install",
    "format": "npx prettier --write 'src/**/*.{ts,less,html}'",
    "analyze": "ng build --configuration=production --stats-json --named-chunks && npx @angular-experts/hawkeye dist/cropmap/stats.json",
    "generate-proxy-win": "cd nswag && generate-proxy.bat",
    "generate-proxy-win:dev": "cd nswag && generate-proxy.bat development",
    "generate-proxy-win:test": "cd nswag && generate-proxy.bat test",
    "generate-proxy-win:prod": "cd nswag && generate-proxy.bat production",
    "generate-proxy-macos": "cd nswag && sh generate-proxy.sh",
    "generate-proxy-macos:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy-macos:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy-macos:prod": "cd nswag && sh generate-proxy.sh production",
    "generate-proxy": "cd nswag && sh generate-proxy.sh",
    "generate-proxy:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy:prod": "cd nswag && sh generate-proxy.sh production",
    "generate:geographic-unit": "node scripts/generate-geographic-unit.mjs",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org doktar-hq --project cropmap ./dist/cropmap && sentry-cli sourcemaps upload --org doktar-hq --project cropmap ./dist/cropmap",
    "kill-port": "npx kill-port 4220"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.8.2",
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@angular/service-worker": "^21.1.0",
    "@dasch-ng/json-viewer": "^1.0.0-rc.0",
    "@mapbox/mapbox-gl-draw": "^1.5.1",
    "@mapbox/mapbox-gl-geocoder": "^5.1.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@phosphor-icons/web": "^2.1.2",
    "@primeng/themes": "^21.0.4",
    "@sentry/angular": "^10.32.1",
    "@turf/turf": "^7.3.4",
    "@types/luxon": "^3.7.1",
    "bootstrap": "^5.3.8",
    "echarts": "^6.0.0",
    "file-saver": "^2.0.5",
    "flatbuffers": "^25.9.23",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "luxon": "^3.7.2",
    "mapbox-gl": "^3.18.1",
    "ngx-echarts": "^21.0.0",
    "nswag": "^14.6.3",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5"
  },
  "devDependencies": {
    "@angular/build": "^21.1.1",
    "@angular/cli": "^21.1.1",
    "@angular/compiler-cli": "^21.1.0",
    "@playwright/test": "^1.59.1",
    "@sentry/cli": "^2.42.2",
    "@types/file-saver": "^2.0.7",
    "@types/node": "^22.10.3",
    "@vitest/coverage-v8": "^4.1.11",
    "@vitest/ui": "^4.1.11",
    "dotenv": "^17.4.0",
    "jsdom": "^29.1.1",
    "less": "^4.2.0",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.9.2",
    "vite": "^6.3.5",
    "vitest": "^4.1.11"
  }
}
